<template>
  <div id="app" class="app-root">
    <!-- 全宽布局：顶栏/底栏背景铺满屏宽，正文区各自用 1440 居中 -->
    <div class="app-shell">
      <ActionBar />
      <!-- 主内容区：各 tab 由 vue-router 独立渲染 -->
      <main class="app-main">
        <router-view />
      </main>
      <!-- 首页底部独立在 HomePage 内；其余页共用站点四栏底栏 -->
      <SiteFooter v-if="!isHomeRoute" />
    </div>
  </div>
</template>

<script>
import ActionBar from './components/ActionBar.vue'
import SiteFooter from './components/SiteFooter.vue'

export default {
  name: 'App',
  components: {
    ActionBar,
    SiteFooter
  },
  computed: {
    /** 首页不展示全站黑底四栏 footer（与原先逻辑一致） */
    isHomeRoute() {
      return this.$route.name === 'home'
    }
  }
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}

#app.app-root {
  background: #fff;
  color: #000;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.app-shell {
  width: 100%;
  box-sizing: border-box;
}

.app-main {
  width: 100%;
  box-sizing: border-box;
}
</style>
